import { render, staticRenderFns } from "./VirtualGroups.vue?vue&type=template&id=fdd00ed8&scoped=true&"
import script from "./VirtualGroups.vue?vue&type=script&lang=js&"
export * from "./VirtualGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd00ed8",
  null
  
)

export default component.exports